import React from 'react'

const Footer = () => {
  return (
    <footer className="footer__container">
      <h6>Designed By</h6>
      <h4>Andy Opote</h4>
      <h6>©2023</h6>
    </footer>
  )
}

export default Footer